<template>
  <div>
    <div
      class="lottery-result-section"
      :style="{
        'background-image':
          'url(' + require('@/assets/front/images/elements/bg-one.jpg') + ')'
      }"
    >
      <div class="ts-container ts-px-4 ts-mx-auto xl:ts-px-0">
        <a-skeleton :active="active" :loading="active" width="60px" :paragraph="{ rows: 15 }" />
        <div v-if="!active">
          <div class="ts-flex ts-justify-center">
            <div class="ts-max-w-2xl">
              <div class="section-header ts-text-center">
                <h2
                  class="section-title ts-capitalize ts-font-heading-font ts-text-heading-color ts-text-5xl ts-font-bold"
                >Latest Lottery Results</h2>
                <p
                  class="ts-block ts-mt-5 ts-text-para-color ts-font-robot ts-leading-relaxed ts-text-base"
                >
                  Check your lotto results online, find all the lotto winning
                  numbers and see if you won the latest lotto jackpots!
                </p>
              </div>
            </div>
          </div>
          <div class="md:ts-flex ts-mt-12">
            <div class="ts-w-full">
              <div class="ts-w-full ts-h-full ts-rounded-lg ts-shadow-md ts-bg-white">
                <h3
                  class="block-title ts-font-heading-font ts-capitalize ts-pt-6 ts-pr-0 ts-pb-4 ts-pl-4 ts-text-2xl ts-tracking-wide ts-text-heading-color ts-font-bold"
                >lottery winning numbers</h3>
                <div class="ts-overflow-scroll">
                  <table class="ts-w-full">
                    <thead>
                      <tr class="ts-bg-gray-200">
                        <th
                          class="ts-text-base ts-font-heading-font ts-font-normal ts-capitalize ts-pl-5 ts-text-heading-color ts-py-1 ts-w-1/2"
                        >lottery</th>
                        <th
                          class="ts-text-base ts-font-heading-font ts-font-normal ts-capitalize ts-text-heading-color ts-text-center ts-w-1/4"
                        >draw date</th>
                        <th
                          class="ts-text-base ts-font-heading-font ts-font-normal ts-capitalize ts-text-heading-color ts-w-1/4"
                        >winning numbers</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template
                        v-if="result_lists.length > 0"
                      >
                        <tr v-for="(data, index) in result_lists" :key="index">
                          <td class="ts-pl-5 ts-py-6 ts-whitespace-no-wrap">
                            <div class="winner-details ts-flex ts-items-center">
                              <img
                                :src="getImage(data.game_set.game_setting)"
                                @error="setNoImage"
                                alt="flag"
                                class="ts-w-8"
                              />
                              <span
                                class="winner-name ts-font-robot ts-text-base ts-ml-2 ts-text-para-color ts-leading-relaxed ts-font-normal"
                              >{{ data.game_set.game_setting.game_setting }}</span>
                            </div>
                          </td>
                          <td class="ts-py-6">
                            <span
                              class="winning-date ts-text-center ts-block ts-text-base ts-text-para-color ts-font-robot"
                            >{{ convertDate(data.game_set.result_date) }}</span>
                          </td>
                          <td class="ts-py-6">
                            <ul class="number-list ts-flex ts-space-x-2 ts-my-auto">
                              <li
                                v-for="(number, index) in spliteString(data.result_number)"
                                :key="index"
                                class="ts-leading-8 ts-font-robot ts-rounded-full ts-text-center ts-border-gray-500 ts-text-heading-color ts-border ts-text-base ts-inline-block ts-h-8 ts-w-8"
                              >{{ number }}</li>
                            </ul>
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr>
                          <td colspan="3" height="300" class="ts-text-center">
                            <h3 class="ts-text-gray-300">No Data</h3>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- <div
              class="md:ts-w-3/12 xl:ts-ml-8 xl:ts-mt-0 ts-w-full ts-mt-8 md:ts-mt-0 md:ts-ml-4"
            >
              <div
                class="ts-w-full ts-rounded-lg ts-shadow-md ts-bg-white ts-p-5 ts-h-full"
              >
                <h3
                  class="block-title ts-font-heading-font ts-capitalize ts-pt-4 ts-pr-0 ts-pb-3 ts-pl-4 ts-text-2xl ts-tracking-wide ts-text-heading-color ts-font-bold ts-border-b ts-border-gray-300"
                >
                  Our Winners
                </h3>
                <div class="winner-single ts-mt-6"
                  v-for="(item, index) in winner_lists"
                  :key="index"
                >
                  <div class="winner-header ts-flex ts-items-center">
                    <img src="@/assets/front/images/flag/1.jpg" alt="flag" />
                    <span
                      class="name ts-ml-3 ts-font-heading-font ts-capitalize ts-font-medium ts-text-lg ts-text-maincolor"
                      > {{ item.dealer ? item.dealer.owner_name : (item.customer ? item.customer.customer_name : null) }}</span
                    >
                  </div>
                  <p class="ts-text-lg ts-font-robot ts-leading-6 ts-mt-3">
                    <span class="lottery-name">{{ item.game_set.game_setting.game_setting }}</span>
                    <span class="date ts-ml-1">{{ convertDate(item.game_set.game_result.result_date) }}</span>
                  </p>
                  <h5
                    class="prize-amount ts-mt-2 ts-font-bold ts-font-heading-font ts-text-2xl"
                    style="color:#02e32d"
                  >
                    {{ item.win_amount }}
                  </h5>
                </div>
                
              </div>
            </div>-->
          </div>
          <div class="ts-w-full ts-mt-8">
            <!-- <a
              href="#"
              class="text-btn ts-font-normal ts-capitalize ts-block ts-text-center ts-underline ts-text-base ts-font-robot"
              style="color:rgba(51, 55, 69, 0.8);"
              >see all result</a
            >-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      active: true,
      result_lists: [],
      winner_lists: [],
      no_image: require('@/assets/front/images/no_image.png')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.active = true
      await this.$store
        .dispatch('front/jackpotResult/fetchResult', {
          include: 'game_set.game_setting',
          current_date: true,
          perPage: 5
        })
        .then(response => {
          this.result_lists = response.data
          this.active = false
        })
      // await this.$store
      //   .dispatch('front/jackpotResult/fetchWinner', {
      //     perPage: 5
      //   })
      //   .then(response => {
      //     this.winner_lists = response.data
      //     this.active = false
      //   })
    },
    spliteString(value) {
      return value.split(',')
    },
    convertDate(dateString) {
      return moment(dateString, 'DD-MM-YYYY').format('DD/MM/YYYY')
    },
    getImage(data) {
      if (data.game_logo) {
        return data.game_logo
      } else {
        return this.no_image
      }
    },
    setNoImage(event) {
      event.target.src = this.no_image
    }
  }
}
</script>
<style lang="css" scoped>
.lottery-result-section {
  padding-top: 120px;
  padding-bottom: 120px;
}
</style>
